import styled from "styled-components";

export const FooterContainer = styled.section`
  display: flex;
  justify-content: center;
`;

export const FooterText = styled.p`
  font-family: kreuz;
  text-transform: uppercase;
  font-size: 11.35vw;
  margin: 0;
`;